/**
 * Middleware for handling clustersie subdomain routing
 */
export default defineNuxtRouteMiddleware((to) => {
  // Only run on client side
  if (process.server) return

  const { getCurrentSubdomain, getSubdomainFromQuery } = useClustersie()
  
  // Get subdomain from query parameter (for development)
  const querySubdomain = getSubdomainFromQuery()
  
  // Get actual subdomain
  const actualSubdomain = getCurrentSubdomain()
  
  // If query subdomain exists and is different from actual, we're in development mode
  if (querySubdomain && querySubdomain !== actualSubdomain) {
    // Store subdomain in session storage for development
    if (process.client) {
      sessionStorage.setItem('dev-subdomain', querySubdomain)
    }
  }
  
  // Validate subdomain
  const validSubdomains = ['main', 'coffee', 'fisheries', 'fruit', 'bittermelon', 'halal', 'mulberry']
  const currentSubdomain = querySubdomain || actualSubdomain
  
  if (!validSubdomains.includes(currentSubdomain)) {
    // Redirect to main if invalid subdomain
    if (process.client) {
      const url = new URL(window.location)
      url.searchParams.delete('subdomain')
      window.location.replace(url.toString())
    }
  }
})